<template>
  <div>
    <Header></Header>
    <section class="top">
      <div>
        <h1>行业资讯</h1>
        <p>这里将分享最新的行业动态，政府政策以及泛物的成长路程</p>
      </div>
    </section>
    <div class="tops">
      <div class="title">
        <h2>{{title}}</h2>
      </div>
      <div class="time">发布时间：{{time}}</div>
    </div>
    <div class="bot">
      <p v-html="content"></p>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "Details",
  data() {
    return {
      arr: [],
      username: "",
      time: "",
      title: "",
    };
  },
  methods: {
    send() {
      console.log(this.$route.query.id, "--00--");
      const id = this.$route.query.id;
      this.$http
        .get("/api/websitemanager_v1//ApiController/getNewsByID/" + id)
        .then((res) => {
          console.log(res);
          console.log(res.data.createTime);
          this.arr = res.data.rows;
          this.time = res.data.createTime;
          this.title = res.data.title;
          this.content = res.data.content;
          console.log(this.content)
        });
    },
    printCpntTitle() {
      console.log(this.cpntTitle);
    },
  },
  created() {
    this.send();
  },
};
</script>

<style scoped="scoped" lang="scss">
  *{
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  .top {
    background-image: url(../../static/img/topbging4.jpg);
    padding: 250px 0 250px;
    // text-align: center;
    position: relative;

    div{
      position: absolute;
      left: 18%;
      top: 42%;
      z-index: 9;
      h1 {
        color: #FFFFFF;
        &::before{
          content: '';
          width: 40px;
          height: 4px;
          margin-left: 8px;
          background-color: #FFFFFF;
          position: absolute;
          top: 60px;
          left: 0;
        }
      }
      p{
        margin-top: 30px;
        font-size: 17px;
        color: #FFFFFF;
      }
    }
  }
.tops {
  width: 60%;
  height: 100%;
  margin: 0 auto;
  padding-top: 100px;
    .time{
        width: 100%;
        padding-top: 20px;
        margin-top: 20px;
        border-top: 1px solid #d9d9d9;
        font-size: 14px !important;
    }
    .title{
        margin-top: 25px;
        h2{
            text-align: center;
        }
    }
}
.bot {
  width: 60%;
  min-height: 330px;
  margin: 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Details.vue